import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Grid,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function StandardEnvironmentFields({
  py_version,
  framework,
  version,
  onChange,
  onTypeErrorChange,
  edit,
}) {
  const environments = useSelector((state) => state.environments);

  const listPythonVersions = () => {
    const versions = new Set(
      environments
        .map((env) => env.py_version)
        .filter((py_version) => py_version)
    );
    return Array.from(versions).map((version) => ({
      value: version,
      label: version,
    }));
  };

  const listFrameworkTypes = (py_version) => {
    const frameworks = new Set(
      environments
        .map((env) =>
          env.py_version === py_version ? env.framework : undefined
        )
        .filter((item) => item)
    );
    return Array.from(frameworks).map((framework) => ({
      value: framework,
      label: framework,
    }));
  };

  const listFrameworkVersions = (py_version, framework) => {
    if (framework === 'Deep Learning') {
      return [{ value: 'latest', label: 'Latest' }];
    }
    const versions = new Set(
      environments
        .map((env) =>
          env.py_version === py_version && env.framework === framework
            ? env.version
            : undefined
        )
        .filter((item) => item)
    );
    return Array.from(versions).map((version) => ({
      value: version,
      label: version,
    }));
  };

  const getEnvironmentIdFromSelections = (py_version, framework, version) => {
    if (framework === 'Deep Learning') {
      const env = environments.find((env) => env.py_version === py_version);
      return env ? env.id : undefined;
    } else {
      const env = environments.find(
        (env) =>
          env.py_version === py_version &&
          env.framework === framework &&
          env.version === version
      );
      return env ? env.id : undefined;
    }
  };

  const handlePyVersionChange = (event) => {
    const new_py_version = event.target.value;
    const new_type = undefined;
    const new_framework = '';
    const new_version = '';
    onChange({
      py_version: new_py_version,
      framework: new_framework,
      version: new_version,
      type: new_type,
    });
    onTypeErrorChange(!Boolean(new_type));
  };

  const handleFrameworkChange = (event) => {
    const new_framework = event.target.value;
    let new_type = undefined;
    let new_version = '';
    if (new_framework === 'Deep Learning') {
      new_version = 'latest';
      new_type = getEnvironmentIdFromSelections(py_version, new_framework);
    }
    onChange({
      framework: new_framework,
      version: new_version,
      type: new_type,
    });
    onTypeErrorChange(!Boolean(new_type));
  };

  const handleVersionChange = (event) => {
    const new_version = event.target.value;
    const new_type = getEnvironmentIdFromSelections(
      py_version,
      framework,
      new_version
    );
    onChange({
      version: new_version,
      type: new_type,
    });
    onTypeErrorChange(false);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth>
            <InputLabel id='py-version-label'>Python Version</InputLabel>
            <Select
              labelId='py-version-label'
              id='py_version'
              value={py_version || ''}
              label='Python Version'
              onChange={handlePyVersionChange}
              disabled={edit}
            >
              {listPythonVersions().map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth>
            <InputLabel id='framework-label'>Framework</InputLabel>
            <Select
              labelId='framework-label'
              id='framework'
              value={framework || ''}
              label='Framework'
              onChange={handleFrameworkChange}
              disabled={!py_version || edit}
            >
              {listFrameworkTypes(py_version).map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth>
            <InputLabel id='version-label'>Framework Version</InputLabel>
            <Select
              labelId='version-label'
              id='version'
              value={version || ''}
              label='Framework Version'
              onChange={handleVersionChange}
              disabled={!framework || edit}
            >
              {listFrameworkVersions(py_version, framework).map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}

